/* eslint-disable array-callback-return */
/* eslint-disable func-names */
import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
import * as actions from '../actions';
import * as c from '../constants';

function ChangeReferenceNumber({
  setFormData,
  formData,
  transactionId,
  updating,
  changeReferenceNumber,
  onClear,
}) {
  const setModal = useContext(ModalContext);
  const [isDisabled, setIsDisabled] = useState(true);

  const handleSubmit = e => {
    e.preventDefault();
    const args = {
      ...formData,
      transaction_history_id: +transactionId,
      reference_number: _.get(formData, 'reference_number')?.toUpperCase() || '',
    };
    changeReferenceNumber(args, () => {
      onClear(e);
      setModal({ isOpen: false });
    });
  };

  const onChange = e => {
    setIsDisabled(false);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label htmlFor="last_name" className="form-label mb-1">
            Reference Number
          </label>
          <input
            className="form-control uppercase"
            type="text"
            name="reference_number"
            onChange={onChange}
            value={_.get(formData, 'reference_number')?.toUpperCase() || ''}
          />
        </div>
        <div className="col-12 d-flex justify-content-center mt-2">
          <button
            disabled={isDisabled || updating}
            onClick={handleSubmit}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary "
          >
            Submit
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

ChangeReferenceNumber.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  changeReferenceNumber: PropTypes.instanceOf(Object).isRequired,
  transactionId: PropTypes.string.isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_REFERENCE_NUMBER) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ChangeReferenceNumber);
